import { render } from "./ProfileDescription.vue?vue&type=template&id=14203834&scoped=true"
import script from "./ProfileDescription.vue?vue&type=script&lang=js"
export * from "./ProfileDescription.vue?vue&type=script&lang=js"

import "@/Common/Styles/profileDescription.scss?vue&type=style&index=0&id=14203834&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14203834"]])

export default __exports__